import { Button, Flex, Tabs, Typography } from 'antd';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import {
  useAuthorization,
  useAuthorizationEffects,
} from '@pages/Authorization/hooks';
import {
  AccessCode,
  Email,
  Password,
} from '@pages/Authorization/ui/components';

import type { FC } from 'react';

import '@pages/Authorization/ui/Authorization.scss';

const { Title, Text } = Typography;

export const Authorization: FC = () => {
  const {
    accessCodeModel,
    activeTabKey,
    authorizeBySecretHandler,
    changeTabHandler,
    clearAuthorizationAccessTokenHandler,
    email,
    emailModel,
    hasUserAuthorized,
    isAccessCodeComponent,
    isSecret,
    passwordModel,
    redirectAuthorizedHandler,
  } = useAuthorization();

  useAuthorizationEffects({
    authorizeBySecretHandler,
    clearAuthorizationAccessTokenHandler,
    hasUserAuthorized,
    isSecret,
    redirectAuthorizedHandler,
  });

  const items = useMemo(
    () => [
      {
        label: 'Email',
        key: 'email',
        children: isAccessCodeComponent ? (
          <AccessCode
            clearServerErrorHandler={accessCodeModel.clearServerErrorHandler}
            codeChangeHandler={accessCodeModel.codeChangeHandler}
            email={email}
            finishHandler={accessCodeModel.finishHandler}
            form={accessCodeModel.form}
            isSubmitLoader={accessCodeModel.isSubmitLoader}
            serverError={accessCodeModel.serverError}
          />
        ) : (
          <Email
            captchaChangeHandler={emailModel.captchaChangeHandler}
            captchaImage={emailModel.captchaImage}
            clearServerErrorHandler={emailModel.clearServerErrorHandler}
            emailChangeHandler={emailModel.emailChangeHandler}
            finishHandler={emailModel.finishHandler}
            form={emailModel.form}
            isPageLoader={emailModel.isPageLoader}
            isSubmitLoader={emailModel.isSubmitLoader}
            serverError={emailModel.serverError}
          />
        ),
      },
      {
        label: 'Пароль',
        key: 'password',
        children: (
          <Password
            captchaChangeHandler={passwordModel.captchaChangeHandler}
            captchaImage={passwordModel.captchaImage}
            clearServerErrorHandler={passwordModel.clearServerErrorHandler}
            emailChangeHandler={passwordModel.emailChangeHandler}
            finishHandler={passwordModel.finishHandler}
            form={passwordModel.form}
            isPageLoader={passwordModel.isPageLoader}
            isSubmitLoader={passwordModel.isSubmitLoader}
            serverError={passwordModel.serverError}
          />
        ),
      },
    ],
    [
      accessCodeModel.clearServerErrorHandler,
      accessCodeModel.codeChangeHandler,
      accessCodeModel.finishHandler,
      accessCodeModel.form,
      accessCodeModel.isSubmitLoader,
      accessCodeModel.serverError,
      emailModel.captchaChangeHandler,
      emailModel.captchaImage,
      emailModel.clearServerErrorHandler,
      emailModel.emailChangeHandler,
      emailModel.finishHandler,
      emailModel.form,
      emailModel.isPageLoader,
      emailModel.isSubmitLoader,
      emailModel.serverError,
      email,
      isAccessCodeComponent,
      passwordModel.captchaChangeHandler,
      passwordModel.captchaImage,
      passwordModel.clearServerErrorHandler,
      passwordModel.emailChangeHandler,
      passwordModel.finishHandler,
      passwordModel.form,
      passwordModel.isPageLoader,
      passwordModel.isSubmitLoader,
      passwordModel.serverError,
    ]
  );

  return (
    <div className="Authorization">
      <div className="Authorization__form-container">
        <Title
          className="Authorization__title"
          level={3}
          data-testid="login-title"
        >
          Вход
        </Title>
        {!isSecret && (
          <Tabs
            activeKey={activeTabKey}
            type="card"
            items={items}
            onChange={changeTabHandler}
          />
        )}
        <Flex align="center" flex={1} vertical>
          <Text className="Authorization__footer-text">Нет аккаунта?</Text>
          <Link to="/sign-up" data-testid="register-organization">
            <Button type="link">Зарегистрировать организацию</Button>
          </Link>
        </Flex>
      </div>
    </div>
  );
};
